export default __webpack_public_path__ + "Logomark Coloured.png";